import "./Badge.scss";

const Badge = ({
    children,
    variant = "outlined",
    Icon,
    iconPosition = "left",
    className = "",
    ...props
}) => {
    const badgeClasses = ["badge", `badge--${variant}`, className]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={badgeClasses} {...props}>
            {Icon && iconPosition === "left" && (
                <Icon className="badge__icon" />
            )}
            {children && <span className="badge__text">{children}</span>}
            {Icon && iconPosition === "right" && (
                <Icon className="badge__icon" />
            )}
        </span>
    );
};

export default Badge;
